"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let AddFixedAssetToRentalModal = class AddFixedAssetToRentalModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    asset;
    onAsset(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("asset");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateRentalAsset', { asset: this.asset, valid_from: this.$fn.today() });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_5534025912102772_auto;
    b_5731695935601903_dataSource;
    dataMembers = ['formId', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_5534025912102772_auto', 'b_5731695935601903_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_5534025912102772_auto: false,
                b_5731695935601903_dataSource: {
                    name: "suggest_rental",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("AddFixedAssetToRentalModal", "Add to Rental"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_1830_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_1836_getActionArgs($event) {
        return {
            result: {
                close: true,
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_1834_getActionArgs($event) {
        return {
            operation: "create_rental_asset",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_1830 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_1830_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_1829 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_1830,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_1829],
        });
        const act_2248226175642056_closeModal_1832 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_1831 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_1832,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_1831],
        });
        const act_1040167445267876_closeModal_1836 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_1836_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1835 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_1836,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_1834 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_1834_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_1835],
        });
        const evh_1040167445267876_submit_1833 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_1834,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_1833],
        });
        const act_1419464017721962_closeComponent_1838 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_1837 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_1838,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_1837],
        });
        return {
            act_7315092382398562_closeModal_1830,
            evh_7315092382398562_close_1829,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_1832,
            evh_2248226175642056_close_1831,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_1836,
            evh_1040167445267876_success_1835,
            act_1040167445267876_request_1834,
            evh_1040167445267876_submit_1833,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_1838,
            evh_1419464017721962_clickPreventStop_1837,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_1834,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], AddFixedAssetToRentalModal.prototype, "asset", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('asset'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AddFixedAssetToRentalModal.prototype, "onAsset", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], AddFixedAssetToRentalModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AddFixedAssetToRentalModal.prototype, "onSize", null);
AddFixedAssetToRentalModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], AddFixedAssetToRentalModal);
exports.default = AddFixedAssetToRentalModal;
vue_property_decorator_1.Vue.component("AddFixedAssetToRentalModal", AddFixedAssetToRentalModal);
